/*! Digital Quran — Mushaf engine (Digital X). Loads before dxl-quran-player.js.
 * Replaces the 160–350 MB PDFs with per-page images (~300 KB) so pages open instantly:
 * - pdf.js (1.3 MB) is never downloaded; the player gets a tiny image renderer instead.
 * - Pages ahead of the reader are preloaded; the first spread is warmed before opening.
 * - Translation editions show the King Fahd Complex page plus that page's translation
 *   (quran.com API) in a side panel, with a language picker that includes Malay.
 */
(function () {
  "use strict";
  var GH = "https://raw.githubusercontent.com/";
  var JD = "https://cdn.jsdelivr.net/gh/";
  var pad3 = function (p) { return ("00" + p).slice(-3); };
  var SRC = {
    kfgqpc: [
      function (p) { return GH + "QuranHub/quran-pages-images/main/kfgqpc/hafs-wasat/" + p + ".jpg"; },
      function (p) { return JD + "QuranHub/quran-pages-images@main/kfgqpc/hafs-wasat/" + p + ".jpg"; }
    ],
    tajweed: [
      function (p) { return GH + "QuranHub/quran-pages-images/main/easyquran.com/hafs-tajweed/" + p + ".jpg"; },
      function (p) { return JD + "QuranHub/quran-pages-images@main/easyquran.com/hafs-tajweed/" + p + ".jpg"; }
    ],
    classic: [
      function (p) { return JD + "GovarJabbar/Quran-PNG@master/" + pad3(p) + ".png"; },
      function (p) { return GH + "GovarJabbar/Quran-PNG/master/" + pad3(p) + ".png"; }
    ]
  };
  // quran.com translation ids — the King Fahd Complex translators where available
  var LANGS = [
    { k: "ms", tr: 39, en: "Malay — Basmeih", ms: "Bahasa Melayu — Basmeih" },
    { k: "english", tr: 20, en: "English — Saheeh International", ms: "Inggeris — Saheeh International" },
    { k: "indonesian", tr: 134, en: "Indonesian — King Fahd Complex", ms: "Indonesia — Kompleks Raja Fahd" },
    { k: "chinese", tr: 56, en: "Chinese — Ma Jian", ms: "Cina — Ma Jian" },
    { k: "french", tr: 31, en: "French — Hamidullah", ms: "Perancis — Hamidullah" },
    { k: "turkish", tr: 77, en: "Turkish — Diyanet", ms: "Turki — Diyanet" },
    { k: "urdu", tr: 54, en: "Urdu — Junagarhi", ms: "Urdu — Junagarhi" },
    { k: "tamil", tr: 133, en: "Tamil — Baqavi", ms: "Tamil — Baqavi" },
    { k: "telugu", tr: 227, en: "Telugu — Abder-Rahim", ms: "Telugu — Abder-Rahim" },
    { k: "portuguese", tr: 43, en: "Portuguese — El-Hayek", ms: "Portugis — El-Hayek" },
    { k: "hausa", tr: 32, en: "Hausa — Gumi", ms: "Hausa — Gumi" },
    { k: "vietnami", tr: 221, en: "Vietnamese — Hasan Abdul-Karim", ms: "Vietnam — Hasan Abdul-Karim" },
    { k: "anko", tr: 795, en: "N'ko — Kanté", ms: "N'ko — Kanté" }
  ];
  var ARABIC = {
    "big-quran.pdf": { src: "kfgqpc", en: "Madinah Mushaf — King Fahd Complex", ms: "Mushaf Madinah — Kompleks Raja Fahd" },
    "standard1-quran.pdf": { src: "tajweed", en: "Colour-coded Tajweed Mushaf", ms: "Mushaf Tajwid Berwarna" },
    "standard2-quran.pdf": { src: "classic", en: "Classic Madinah Mushaf", ms: "Mushaf Madinah Klasik" }
  };
  var FILES = ["big-quran.pdf", "standard1-quran.pdf", "standard2-quran.pdf", "english-quran.pdf", "indonesian-quran.pdf",
    "chinese-quran.pdf", "french-quran.pdf", "turkish-quran.pdf", "urdu-quran.pdf", "tamil-quran.pdf", "telugu-quran.pdf",
    "portuguese-quran.pdf", "hausa-quran.pdf", "vietnami-quran.pdf", "anko-quran.pdf"];

  function edFor(file) {
    if (ARABIC[file]) return { src: ARABIC[file].src, lang: null };
    var k = file.replace("-quran.pdf", "");
    for (var i = 0; i < LANGS.length; i++) if (LANGS[i].k === k) return { src: "kfgqpc", lang: LANGS[i] };
    return { src: "kfgqpc", lang: null };
  }
  function uiLang() {
    var en = document.getElementById("dxq-langEn");
    return en && en.classList.contains("on") ? "en" : "ms";
  }

  /* ------------------------------------------------------------ image cache */
  var IMG = new Map();
  function loadImg(src, p) {
    var key = src + ":" + p;
    if (IMG.has(key)) return IMG.get(key);
    var urls = SRC[src];
    var pr = new Promise(function (resolve, reject) {
      var i = 0;
      (function attempt() {
        var im = new Image(); // no crossOrigin: pages are only drawn, never read back, so CORS can't block them
        im.decoding = "async";
        im.onload = function () { (im.decode ? im.decode() : Promise.resolve()).catch(function () {}).then(function () { resolve(im); }); };
        im.onerror = function () { if (++i < urls.length) return attempt(); IMG.delete(key); reject(new Error("page " + p)); };
        im.src = urls[i](p);
      })();
    });
    IMG.set(key, pr);
    if (IMG.size > 80) IMG.delete(IMG.keys().next().value);
    return pr;
  }
  function warm(src, from, count) {
    for (var p = Math.max(1, from); p < from + count && p <= 604; p++) loadImg(src, p).catch(function () {});
  }

  function imageDoc(src) {
    return {
      numPages: 604,
      getPage: function (n) {
        warm(src, n + 1, 6);
        if (n > 2) warm(src, n - 2, 2);
        return loadImg(src, n).then(function (im) {
          var W = im.naturalWidth, H = im.naturalHeight;
          return {
            getViewport: function (o) { var s = (o && o.scale) || 1; return { width: W * s, height: H * s, scale: s }; },
            render: function (o) {
              var ctx = o.canvasContext, vp = o.viewport;
              ctx.fillStyle = "#fff";
              ctx.fillRect(0, 0, vp.width, vp.height);
              ctx.imageSmoothingEnabled = true;
              ctx.imageSmoothingQuality = "high";
              ctx.drawImage(im, 0, 0, vp.width, vp.height);
              return { promise: Promise.resolve(), cancel: function () {} };
            },
            cleanup: function () {}
          };
        });
      },
      cleanup: function () {},
      destroy: function () { return Promise.resolve(); }
    };
  }

  /* ------------------------------------------- pdf.js replacement (no download) */
  var stubLib = {
    GlobalWorkerOptions: {},
    getDocument: function (arg) {
      var url = String((arg && (typeof arg === "string" ? arg : arg.url)) || "");
      var file = url.split("/").pop().split("?")[0];
      var ed = edFor(file);
      Trans.prepare(ed.lang);
      return { promise: Promise.resolve(imageDoc(ed.src)), destroy: function () {} };
    }
  };
  var origAppend = Node.prototype.appendChild;
  Node.prototype.appendChild = function (node) {
    if (node && node.tagName === "SCRIPT" && /pdfjs-dist/.test(node.src || "")) {
      window.pdfjsLib = stubLib;
      setTimeout(function () { if (typeof node.onload === "function") node.onload(); }, 0);
      return node;
    }
    return origAppend.call(this, node);
  };
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    if (/pdfjs-dist\/.*pdf\.worker/.test(url)) return Promise.resolve(new Response("", { status: 200 }));
    if (/digital-x-quran-pdf\//.test(url)) return Promise.reject(new TypeError("dxq: pdf replaced by page images"));
    return nativeFetch.apply(this, arguments);
  };

  /* ----------------------------------------------------- translation panel */
  var Trans = (function () {
    var panel, list, sel, cur = null, lastKey = "", timer = 0, cache = new Map();
    function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
    function build() {
      var book = document.querySelector("#dxq-bookWrap .qbook");
      if (!book || panel) return !!panel;
      panel = el("aside", "dqx-trans");
      panel.setAttribute("aria-label", "Translation");
      var head = el("div", "dqx-trans-h");
      var ttl = el("b", "", "");
      ttl.id = "dqxTransTitle";
      sel = el("select", "dqx-trans-sel");
      sel.setAttribute("aria-label", "Translation language");
      sel.addEventListener("change", function () {
        cur = LANGS[+sel.value];
        try { localStorage.setItem("dqx-trans-lang", cur.k); } catch (e) {}
        lastKey = ""; tick();
      });
      head.appendChild(ttl); head.appendChild(sel);
      list = el("div", "dqx-trans-list");
      list.setAttribute("aria-live", "polite");
      panel.appendChild(head); panel.appendChild(list);
      var tog = el("button", "dqx-trans-tog");
      tog.type = "button";
      tog.addEventListener("click", function () { book.classList.toggle("dqx-trans-open"); label(); });
      book.appendChild(panel); book.appendChild(tog);
      label();
      return true;
    }
    function label() {
      var L = uiLang();
      var ttl = document.getElementById("dqxTransTitle");
      if (ttl) ttl.textContent = L === "en" ? "Translation" : "Terjemahan";
      var tog = document.querySelector("#dxq-bookWrap .dqx-trans-tog");
      var open = document.querySelector("#dxq-bookWrap .qbook.dqx-trans-open");
      if (tog) tog.textContent = open ? (L === "en" ? "Hide translation" : "Tutup terjemahan") : (L === "en" ? "Show translation" : "Lihat terjemahan");
      if (sel) {
        var v = sel.value;
        sel.innerHTML = "";
        LANGS.forEach(function (l, i) { var o = el("option", "", l[L]); o.value = i; sel.appendChild(o); });
        sel.value = cur ? LANGS.indexOf(cur) : (v || 0);
      }
    }
    function prepare(lang) {
      if (!build()) { setTimeout(function () { prepare(lang); }, 50); return; }
      var book = document.querySelector("#dxq-bookWrap .qbook");
      if (lang) {
        cur = lang;
      } else {
        var saved = null;
        try { saved = localStorage.getItem("dqx-trans-lang"); } catch (e) {}
        cur = LANGS.filter(function (l) { return l.k === saved; })[0] || (uiLang() === "en" ? LANGS[1] : LANGS[0]);
      }
      book.classList.toggle("dqx-has-trans", !!lang);
      book.classList.toggle("dqx-trans-open", !!lang && !matchMedia("(max-width:720px)").matches);
      label();
      lastKey = "";
      clearInterval(timer);
      timer = setInterval(tick, 350);
      tick();
    }
    function pagesShown() {
      var inp = document.getElementById("dxq-bookPage");
      var p = Math.max(1, Math.min(604, +(inp && inp.value) || 1));
      if (matchMedia("(max-width:720px)").matches) return [p];
      var a = 2 * Math.floor((p - 1) / 2) + 1;
      return a + 1 <= 604 ? [a, a + 1] : [a];
    }
    function fetchPage(p, id) {
      var key = id + ":" + p;
      if (cache.has(key)) return cache.get(key);
      var pr = fetch("https://api.quran.com/api/v4/verses/by_page/" + p + "?translations=" + id + "&per_page=50&fields=text_uthmani")
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (j) { return j.verses || []; });
      pr.catch(function () { cache.delete(key); });
      cache.set(key, pr);
      return pr;
    }
    function clean(html) {
      // footnote markers can be nested or malformed in the source data: peel them innermost-first
      var s = String(html || ""), prev;
      do { prev = s; s = s.replace(/<sup[^<>]*>[^<]*<\/sup>/gi, ""); } while (s !== prev);
      s = s.replace(/<\/?sup[^>]*>?/gi, "");
      var d = document.createElement("div");
      d.innerHTML = s;
      return d.textContent
        .replace(/(\p{L})\d{1,2}(?=[\s.,;:!?)]|$)/gu, "$1") // a footnote digit glued to a word ("Tuhan3")
        .replace(/\s+([.,;:!?])/g, "$1")
        .replace(/\s+/g, " ").trim();
    }
    function tick() {
      var wrap = document.getElementById("dxq-bookWrap");
      if (!wrap || wrap.hidden) { clearInterval(timer); return; }
      var book = wrap.querySelector(".qbook");
      if (!book || !book.classList.contains("dqx-has-trans") || !cur) return;
      var pages = pagesShown();
      var key = cur.tr + "|" + pages.join(",");
      if (key === lastKey) return;
      lastKey = key;
      pages.forEach(function (p) { fetchPage(p + pages.length, cur.tr).catch(function () {}); });
      var L = uiLang();
      list.innerHTML = "";
      list.appendChild(el("p", "dqx-trans-note", L === "en" ? "Loading…" : "Memuatkan…"));
      Promise.all(pages.map(function (p) { return fetchPage(p, cur.tr); })).then(function (sets) {
        if (key !== lastKey) return;
        list.innerHTML = "";
        // right-hand page first: a mushaf spread reads right to left
        var ordered = pages.length === 2 ? [[pages[0], sets[0]], [pages[1], sets[1]]] : [[pages[0], sets[0]]];
        ordered.forEach(function (pair) {
          var h = el("h3", "dqx-trans-pg", (L === "en" ? "Page " : "Halaman ") + pair[0]);
          list.appendChild(h);
          pair[1].forEach(function (v) {
            var t = (v.translations && v.translations[0]) || {};
            var row = el("p", "dqx-trans-v");
            var ref = el("span", "dqx-trans-ref", v.verse_key);
            var txt = el("span", "dqx-trans-txt", clean(t.text));
            txt.dir = "auto";
            row.appendChild(ref); row.appendChild(txt);
            list.appendChild(row);
          });
        });
        list.scrollTop = 0;
      }).catch(function () {
        if (key !== lastKey) return;
        lastKey = "";
        list.innerHTML = "";
        list.appendChild(el("p", "dqx-trans-note", L === "en" ? "Couldn't load the translation. Check your connection — it will retry." : "Terjemahan tidak dapat dimuatkan. Semak sambungan anda — ia akan dicuba semula."));
      });
    }
    return { prepare: prepare, relabel: label };
  })();

  /* ------------------------------------------- edition names in the picker */
  function relabelEditions() {
    var s = document.getElementById("dxq-bookEd");
    if (!s || !s.options.length) return;
    var L = uiLang();
    Array.prototype.forEach.call(s.options, function (o) {
      var f = FILES[+o.value];
      if (!f) return;
      var name;
      if (ARABIC[f]) name = ARABIC[f][L];
      else {
        var l = edFor(f).lang;
        name = l ? (L === "en" ? "Arabic + " : "Arab + ") + l[L] : o.textContent;
      }
      if (o.textContent !== name) o.textContent = name;
    });
    var sub = document.getElementById("dxq-bookSub");
    var f0 = FILES[+s.value];
    if (sub && f0) {
      var t = ARABIC[f0] ? ARABIC[f0][L] : (L === "en" ? "Madinah Mushaf with translation" : "Mushaf Madinah bersama terjemahan");
      if (sub.textContent !== t) sub.textContent = t;
    }
  }

  /* ------------------------------------------- warm the first spread early */
  function savedEdition() {
    try {
      var sv = JSON.parse(localStorage.getItem("quran-book-v1")) || {};
      var ed = FILES[sv.ed] ? sv.ed : 0;
      var page = (sv.pages && sv.pages[ed]) || (sv.ed === ed && sv.page) || 1;
      return { src: edFor(FILES[ed]).src, page: page };
    } catch (e) { return { src: "kfgqpc", page: 1 }; }
  }
  var warmed = false;
  function warmFirst() {
    if (warmed) return;
    warmed = true;
    var s = savedEdition();
    warm(s.src, 2 * Math.floor((s.page - 1) / 2) + 1, 4);
  }

  function init() {
    var watch = function () { relabelEditions(); Trans.relabel(); };
    var s = document.getElementById("dxq-bookEd");
    if (s) try { new MutationObserver(watch).observe(s, { childList: true, subtree: true, characterData: true }); s.addEventListener("change", function () { setTimeout(relabelEditions, 0); }); } catch (e) {}
    ["dxq-langEn", "dxq-langMs"].forEach(function (id) {
      var b = document.getElementById(id);
      if (b) b.addEventListener("click", function () { setTimeout(watch, 0); });
    });
    relabelEditions();
    ["dqMushaf", "dxq-bookOpen1"].forEach(function (id) {
      var b = document.getElementById(id);
      if (b) ["pointerenter", "focus", "touchstart"].forEach(function (ev) { b.addEventListener(ev, warmFirst, { passive: true, once: true }); });
    });
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 2500); };
    setTimeout(function () { idle(warmFirst); }, 3000);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
